<template>
  <!-- 富文本 -->
  <div :style="{height: reload ? `${height}px` : 'auto'}">
    <editor v-if="!reload" ref="tinymceReft" v-model="content" @change="changeHandler" :init="init" :disabled="disabled"></editor>
  </div>
</template>
 
 
<script>
import tinymce from "tinymce/tinymce";
import Editor from '@tinymce/tinymce-vue';
import "tinymce/icons/default/icons";
import "tinymce/themes/silver";
import "tinymce/plugins/image";
import "tinymce/plugins/media";
import "tinymce/plugins/table";
import "tinymce/plugins/lists";
import "tinymce/plugins/contextmenu";
import "tinymce/plugins/wordcount";
import "tinymce/plugins/colorpicker";
import "tinymce/plugins/textcolor";
import "tinymce/plugins/preview";
import "tinymce/plugins/code";
import "tinymce/plugins/link";
import "tinymce/plugins/advlist";
import "tinymce/plugins/codesample";
import "tinymce/plugins/hr";
import "tinymce/plugins/fullscreen";
import "tinymce/plugins/textpattern";
import "tinymce/plugins/searchreplace";
import "tinymce/plugins/autolink";
import "tinymce/plugins/directionality";
import "tinymce/plugins/visualblocks";
import "tinymce/plugins/visualchars";
import "tinymce/plugins/template";
import "tinymce/plugins/charmap";
import "tinymce/plugins/nonbreaking";
import "tinymce/plugins/insertdatetime";
import "tinymce/plugins/imagetools";
import "tinymce/plugins/autosave";
// import "tinymce/plugins/autoresize"; 
import "tinymce/plugins/print"; 
import "tinymce/plugins/anchor";
import "tinymce/plugins/emoticons";
import "tinymce/plugins/fullpage";
import "tinymce/plugins/pagebreak";
import "tinymce/plugins/paste";

// import "tinymce/plugins/help";

export default {
  components: {
    Editor
  },
  name: 'l-neweditor',
  props: {
    value: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    },
    plugins: {
      type: [String, Array],
      default:
        "preview searchreplace autolink directionality visualblocks visualchars fullscreen image link media template code codesample table charmap hr nonbreaking insertdatetime advlist lists wordcount imagetools textpattern autosave print anchor emoticons fullpage pagebreak paste"
    },
    height: {
      default: 300
    },
    placeholder: {
      default: '请输入内容'
    },
    statusbar: {//状态栏指的是编辑器最底下、左侧显示dom信息、右侧显示Tiny版权链接和调整大小的那一条。默认是显示的，设为false可将其隐藏。
      default: false
    },
    menubar: {
      default: false,
    },
    toolbar: {
      type: [String, Array],
      default:
        "code undo redo restoredraft | cut copy paste pastetext | forecolor backcolor bold italic underline strikethrough link codesample anchor emoticons| alignleft aligncenter alignright alignjustify outdent indent formatpainter pagebreak | \
    styleselect formatselect fontselect fontsizeselect | bullist numlist | blockquote subscript superscript removeformat | \
    table image media charmap hr insertdatetime | fullpage fullscreen preview print"
    },
    resize: {
      default: true // true（仅允许改变高度）, false（完全不让你动）, 'both'（宽高都能改变，注意引号
    },
    toolbar_mode: {
      default: 'sliding' // floating / sliding / scrolling / wrap
    }
    
  },
  watch: {
    value(newVal) {
      if (newVal != this.content) this.setContent(newVal);
    },
    height () {
      this.init.height = this.height
      this.reloadEditor()
    },
    menubar () {
      this.init.menubar = this.menubar
      this.reloadEditor()
    },
    placeholder () {
      this.init.placeholder = this.placeholder
      this.reloadEditor()
    },
    resize () {
      this.init.resize = this.resize
      this.reloadEditor()
    },
    toolbar_mode () {
      this.init.toolbar_mode = this.toolbar_mode
      this.reloadEditor()
    },
    statusbar () {
      this.init.statusbar = this.statusbar
      this.reloadEditor()
    },
    content(newVal) {
      let value = newVal

      // 图片需要做一次转化
      // if(this.apiUrl){
      //   const delta = this.quill.getContents()
      //   const len = delta.ops.length
      //   for(let i = 0;i < len;i++){
      //     const deltaItem = delta.ops[i]
      //     if(deltaItem.insert && deltaItem.insert.image && deltaItem.insert.image.indexOf(this.apiUrl) > -1){
      //       const imageUrl = `${deltaItem.insert.image.replace(this.apiUrl + 'system/annexesfile/','{learun_img_api}').replace('token=' + this.token,'{learun_img_token}')}`
      //       value = value.replace(deltaItem.insert.image,imageUrl)
      //     }
      //   }
      // }
      
      value = value.replace(/token=\S+\"/g, '{learun_img_token}"').replaceAll(this.apiUrl + 'system/annexesfile/','{learun_img_api}')
      // this.content = value
      this.$emit("input", value)
      this.$emit("change", value)
    },
  },
  data() {
    return {
      reload: false,
      //初始化配置
      init: {
        relative_urls: false,
        convert_urls: false, //设置为false，禁止将编辑器中的图片地址自动转为相对路径
        default_link_target: "_blank", // 默认链接打开方式
        link_assume_external_targets: true, // 协议前缀补齐提示
        //menubar: true, // 菜单栏显隐https://www.jellyfishdata.com:9777/cdn/static/langs/zh-Hans.js
        language_url: "/static/langs/zh-Hans.js",
        //language_url: '../../static/tinymce/langs/zh_CN.js', // vue-cli2.x
        language: "zh_CN",
        skin_url: "/static/skins/ui/oxide",
        //skin_url: '../../static/tinymce/skins/ui/oxide', // vue-cli2.x
        //content_css: '../../static/tinymce/skins/content/default/content.css',// vue-cli2.x
        // menubar: this.menubar ? 'file edit insert view format table tools help' : true, // 菜单栏配置
        menubar: this.menubar, // 菜单栏配置
        height: this.height,
        min_height: 300,
        // max_height: 770,
        toolbar_mode: this.toolbar_mode, // floating / sliding / scrolling / wrap
        plugins: this.plugins,
        toolbar: this.toolbar,
        content_style: "p {margin: 5px 0;}",
        fontsize_formats: "12px 14px 16px 18px 24px 36px 48px 56px 72px",
        font_formats:
          "微软雅黑=Microsoft YaHei,Helvetica Neue,PingFang SC,sans-serif;苹果苹方=PingFang SC,Microsoft YaHei,sans-serif;宋体=simsun,serif;仿宋体=FangSong,serif;黑体=SimHei,sans-serif;Arial=arial,helvetica,sans-serif;Arial Black=arial black,avant garde;Book Antiqua=book antiqua,palatino;",
        branding: false,
        emoticons_database_url: '/static/emojis.js',
        paste_data_images: true, // 默认是false的，记得要改为true才能粘贴
        images_file_types: 'jpeg,jpg,png,gif,bmp,webp',
        placeholder: this.placeholder,
        resize: this.resize,
        statusbar: this.statusbar,
        // 图片上传
        images_upload_handler: (blobInfo, success, failure) => {
          if (!this.lr_chunkedUpload) return success('data:image/jpeg;base64,' + blobInfo.base64())
          const option = {
            file:blobInfo.blob(),
            data:{
              folderId:this.$uuid()
            }
          }
          this.lr_chunkedUpload(option,async(data)=>{
            const api = window.$api.system.img
            const url = await this.$awaitWraper(api.upload('learun_img',data))
            if(url){
              success(`${this.apiUrl}system/annexesfile/${url}?token=${this.token}`)
            }
            else{
              failure('上传失败')
            }
          })



          // const img = 'data:image/jpeg;base64,' + blobInfo.base64()
          // success(img)
 
          // const formData = new FormData()
          // formData.append('file', blobInfo.blob())
          // reserveTableFoodDescribe(formData).then(res => {
          //   if (res.code === '10000') {
          //     const file = res.data
          //     success(file.url)
          //     return
          //   }
          //   failure('上传失败')
          // }).catch(() => {
          //   failure('上传出错')
          // })
        }
      },
      content: ''
    };
  },
  mounted() {
    this.setContent(this.value)
    tinymce.init({});
    
  },
  methods: {
    reloadEditor() {
      this.reload = true
      this.$nextTick(() => {
        this.reload = false
      })
    },
    insertContent(content){
      // 获取当前编辑器实例
      const editor = tinymce.activeEditor;
      // 在光标位置插入内容
      editor.insertContent(content);

    },
    setContent(val) {
      // 图片格式转化
      val = val || ""
      val = val.replace(/{learun_img_api}/g,`${this.apiUrl}system/annexesfile/`)
      .replace(/{learun_img_token}/g,`token=${this.token}`)
      let isInit = false
      if (!this.content && val) isInit = true
      this.content = val
      if (isInit) {
        this.reload = true
        this.$nextTick(() => {
          this.reload = false
        })
      }
    },
    changeHandler (val) {
    }
  },
  // watch: {
  //   value(newValue) {
  //     this.content = newValue;
  //   },
  //   content(newValue) {
  //     this.$emit("input", newValue);
  //   }
  // }
};
</script>
<style scoped lang="scss">
</style>